import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';
import { HiOutlineTrash } from 'react-icons/hi';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../redux/library/selector';


export const ConvertFileBasicInfoComponent = ({ parsingRule,deleteSelectedService, openConfirmation, handleClose, fieldConversions,handleOpen,formatType,fieldType,selectedConvertFile, handleInnerBasicFormChange, handleInnerFormChange,convertFile,handleFormItemChange}: any) => {
  return (
        <>
   <AccordionContainer
                  child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                          label="Parsing Rule "
                          labelField="Name"
                          list={parsingRule}
                          onValueChange={(event: any, newValue: any) => {
                            handleInnerBasicFormChange(
                              event.target.value,
                              'ParsingRuleId',
                            );
                          }}
                          optionName='Choose Parsing Rule'
                          type="select"
                          value={selectedConvertFile?.ParsingRuleId}
                          valueField="Id"
                        />
                     
                        <InputContainer
                          label="Input File"
                          labelField="InputFile"
                          onValueChange={(event: any, newValue: any) => {
                            handleInnerBasicFormChange(
                              event.target.value,
                              'InputFile',
                            );
                          }}
                          type="text"
                          value={selectedConvertFile?.InputFile}
                        />
                     
                        <InputContainer
                          label="Output File"
                          labelField="OutputFile"
                          onValueChange={(event: any, newValue: any) => {
                            handleInnerBasicFormChange(
                              event.target.value,
                              'OutputFile',
                            );
                          }}
                          type="text"
                          value={selectedConvertFile?.OutputFile}
                        />
                    </div>
                  }
                  expandedPanel="BasicInfo"
                  headerTitle="Basic Information"
                />
                <AccordionContainer
                  child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                          label="Input File Type "
                          labelField="Text"
                          list={formatType}
                          onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                              event.target.value,
                              'Options.InputFileType',
                              convertFile?.Options,
                            );
                          }}
                          optionName='Choose Input FileType'
                          type="select"
                          value={convertFile?.Options?.InputFileType}
                          valueField="Text"
                        />
                     
                        <InputContainer
                          label="Output File Type "
                          labelField="Text"
                          list={formatType}
                          onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                              event.target.value,
                              'Options.OutputFileType',
                              convertFile?.Options,
                            );
                          }}
                          optionName='Choose Output FileType'
                          type="select"
                          value={convertFile?.Options?.OutputFileType}
                          valueField="Text"
                        />
                      
                        <InputContainer
                          label="Input File Has Header"
                          labelField="InputFileHasHeader"
                          onValueChange={(event: any) => {
                            handleInnerBasicFormChange(
                              event,
                              'Options.InputFileHasHeader',
                              parsingRule?.Options,
                            );
                          }}
                          type="checkbox"
                          value={parsingRule?.Options?.InputFileHasHeader}
                        />
                     </div>
                  }
                  expandedPanel="Options"
                  headerTitle="Options"
                />
    <AccordionContainer
      child={
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border border-gray-300">
            <thead>
              <tr>
                <th className="px-4 py-2 border-b border-gray-300">Delete</th>
                <th className="px-4 py-2 border-b border-gray-300">INPUTFIELD INDEX</th>
                <th className="px-4 py-2 border-b border-gray-300">INPUTFIELD TYPE</th>
                <th className="px-4 py-2 border-b border-gray-300">OUTPUTFIELD INDEX</th>
                <th className="px-4 py-2 border-b border-gray-300">OUTPUTFIELD TYPE</th>
                <th className="px-4 py-2 border-b border-gray-300">OUTPUTHEADER TEXT</th>
              </tr>
            </thead>
            <tbody>
              {_.map(fieldConversions, (cardValue, index) => (
                <tr key={index} className="h-20">
                  <td className="px-4 py-2 border-b border-gray-300">
                  <button className="text-red-500 hover:text-red-700" onClick={async () => deleteSelectedService(cardValue, index)}>
                    <HiOutlineTrash className="w-6 h-6" />
                  </button>
                  </td>
                  <td className="px-4 py-2 border-b border-gray-300"><InputContainer
                      labelField="InputField Index"
                      onValueChange={(event:any) => {
                        handleFormItemChange({
                          value: event.target.value,
                          field: 'InputFieldIndex',
                          idx: index,
                        });
                      }}
                      type="text"
                      value={cardValue?.InputFieldIndex}
                    /></td>
                  <td className="px-4 py-2 border-b border-gray-300">
                    <InputContainer
                      labelField="Text"
                      list={fieldType}
                      onValueChange={(event: any) => {
                        handleFormItemChange({
                          value: event.target.value,
                          field: 'InputFieldType',
                          idx: index,
                        });
                      }}
                      type="text"
                      value={cardValue?.InputFieldType}
                      valueField="Text"
                    />
                  </td>
                  <td className="px-4 py-2 border-b border-gray-300"> <InputContainer
                      labelField="Output Field Index"
                      onValueChange={(event:any) => {
                        handleFormItemChange({
                          value: event.target.value,
                          field: 'OutputFieldIndex',
                          idx: index,
                        });
                      }}
                      type="text"
                      value={cardValue?.OutputFieldIndex}
                    /></td>
                  <td className="px-4 py-2 border-b border-gray-300">
                    <InputContainer
                      labelField="Text"
                      list={fieldType}
                      onValueChange={(event:any) => {
                        handleFormItemChange({
                          value: event.target.value,
                          field: 'OutputFieldType',
                          idx: index,
                        });
                      }}
                      type="text"
                      value={cardValue?.OutputFieldType}
                      valueField="Text"
                    />
                  </td>
                  <td className="px-4 py-2 border-b border-gray-300">
                    <InputContainer
                      labelField="OutputHeaderText"
                      onValueChange={(event:any) => {
                        handleFormItemChange({
                          value: event.target.value,
                          field: 'OutputHeaderText',
                          idx: index,
                        });
                      }}
                      type="text"
                      value={cardValue?.OutputHeaderText}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      }
                  expandedPanel="Field Conversions"
                  headerTitle="Field Conversions"
                />
    </>
  )
}
export default ConvertFileBasicInfoComponent;
